"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgEvent(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M18.179 0c.384 0 .7.285.75.655l.008.103-.001 1.01h2.578c.948 0 1.718.77 1.718 1.718v18.796c0 .949-.77 1.718-1.718 1.718H2.718C1.769 24 1 23.23 1 22.282V3.486c0-.948.77-1.718 1.718-1.718h2.576V.758a.758.758 0 011.51-.103l.007.103-.001 1.01h10.611V.758c0-.419.34-.758.758-.758zM5.294 3.284H2.718a.202.202 0 00-.195.149l-.007.053v18.796c0 .093.063.171.148.195l.054.007h18.796a.202.202 0 00.195-.148l.007-.054V3.486a.202.202 0 00-.149-.195l-.053-.007h-2.578V4.8a.758.758 0 01-1.508.103l-.007-.103V3.284H6.81V4.8a.758.758 0 01-1.508.103L5.295 4.8l-.001-1.516zm6.822 4.8c.383 0 .7.285.75.655l.008.103-.001 3.284h3.285a.758.758 0 01.103 1.51l-.103.006h-3.285v3.284a.758.758 0 01-1.508.103l-.007-.103-.001-3.284H8.074a.758.758 0 01-.103-1.509l.103-.007h3.283V8.842c0-.418.34-.758.759-.758z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgEvent;
exports.default = _default;